import { render } from "./AudioControl.vue?vue&type=template&id=33512619&scoped=true"
import script from "./AudioControl.vue?vue&type=script&lang=js"
export * from "./AudioControl.vue?vue&type=script&lang=js"

import "./AudioControl.vue?vue&type=style&index=0&id=33512619&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33512619"]])

export default __exports__